export default __webpack_public_path__ + "static/media/kw.bd73ccba.svg";